import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, LoadingController } from 'ionic-angular';
import { RcsConnectorIndexDbProvider } from '../../providers/rcs-connector-index-db/rcs-connector-index-db';

import { ReplacementPartsProvider } from '../../providers/replacement-parts/replacement-parts';
import { AsyncSubject, Subject, BehaviorSubject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'replacement-parts-page',
  templateUrl: 'replacement-parts.html'
})
export class ReplacementPartsPage implements OnInit{

  public products = []
  public packages = []
  public amount_sync_items: number = 0
  private process = new BehaviorSubject(false);
  private job_id:number
  private loading: Loading;

  constructor(public nav_controller: NavController,
              private kd_database_service: RcsConnectorIndexDbProvider,
              public nav_params: NavParams,
              private sync_replacement_service: ReplacementPartsProvider,
              public loadingCtrl: LoadingController,
            ) {}

  ngOnInit(): void {
    this.products = [];
    this.packages = [];
    this.amount_sync_items = 0;
    this.process = new BehaviorSubject(false);
    this.job_id = 0;
    this.loading = null;
    this.load_replacement_items();
  }

  private showLoading():void {
    this.loading = this.loadingCtrl.create({
      content: 'Lieferung wird ausgeführt',
      dismissOnPageChange: true
    });
    this.loading.present();
  }

  private load_replacement_items(){
    console.log("LOADING");
    this.job_id = this.nav_params.get('job_id');
    this.kd_database_service.get_all_records('replacement_items').subscribe(
      results => {
        for(let result of results){
          if (result.job_id === this.job_id){
            if (result.product_id !== false){
              this.products.push(result);
            }else{
              result.orgin_quantity = result.quantity
              this.packages.push(result);
            }
            if (result.quantity > 0){
              this.amount_sync_items ++;
            }
          }
        }
      }
    )
  }

  public add_quantity(_package){
    if (_package.quantity < _package.orgin_quantity){
      if (_package.quantity == 0){
        this.amount_sync_items ++;
      }
      _package.quantity ++;
    }
  }

  public remove_quantity(_package){
    if (_package.quantity > 0){
      _package.quantity --;
      if (_package.quantity == 0){
        this.amount_sync_items --;
      }
    }
  }

  public deliever(){
    this.showLoading();
    let items = this.products.concat(this.packages);
    let count = 0;
    this.process = new BehaviorSubject(false);
    this.process.subscribe(
      finished => { 
        if(finished){ this.sync_replacement_service.develiever_replacement_parts(this.job_id); } }
    )

    for (let item of items){
      if (item.quantity === 0){
        item.state = 'unlink';
      }else{
        item.state = 'deliever';
      }
      this.kd_database_service.update_record('replacement_items', item, item.id).subscribe(
        success => {
          count ++;
          if (count === items.length){
            this.process.next(true);
            this.process.complete();
          }
        }
      );
    }

    this.sync_replacement_service.transfer_prozess = new AsyncSubject();
    this.sync_replacement_service.transfer_prozess.subscribe(
      finished => { if (finished !== 'false'){
        if (finished === 'true_online'){
          this.kd_database_service.get_record_by_key('jobs', this.job_id).subscribe(
            result => {
              result.state_name = 'zu bearbeiten';
              this.kd_database_service.update_record('jobs', result, this.job_id).subscribe(
                complete => {
                  this.loading.dismiss();
                  this.nav_controller.setPages([{'page': 'CalenderPage', 'params': {}}]);
                }
              )
            }
          )
        }
        if ((finished === 'true_offline')){
          this.loading.dismiss();
          this.nav_controller.setPages([{'page': 'CalenderPage', 'params': {}}]);
        }
      } }
    )
  }

  public abort(){
    this.nav_controller.setPages([{'page': 'CalenderPage', 'params': {}}]);
  }


}



// WEBPACK FOOTER //
// ./src/pages/replacement-parts/replacement-parts.ts